/**
 * this component renders a gallery of models.
 * you put in an array of models and optionally the bar for castings and it iteratively 
 * puts the thumbnails and names of the given models in a structured gallery  
 */
import React, { } from 'react';
import { useNavigate } from 'react-router-dom';
import RenderModel from './RenderModel';


const RenderModels = ({ models = [], castingBar = () => { } }) => {
    const navigate = useNavigate();
    const handleModelClick = (modelId) => {
        navigate(`/model/${modelId}`);
    };

    return (
        <div className="model-list">
            {console.log("modelsinRender", models)}
            {models.length > 0 ? (
                models.map((model) => (
                    <div onClick={() => handleModelClick(model.id)} style={{ cursor: 'pointer' }} key={model.id + "renderModels"}>
                        <RenderModel model={model} castingBar={castingBar} />
                    </div>
                ))
            ) : (
                <div>No models found</div>
            )}
        </div>
    );

};

export default RenderModels;
